export * from '@yanolja-rnd/ya-com-modal';
export type * from '@yanolja-rnd/ya-com-modal';
